module.exports = __webpack_public_path__ + "static/img/手机壳.abefe9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/手机壳.png
// module id = 0Ge3
// module chunks = 1